import http from "../../../core/services/http.service";

const DependedFieldsService = {
    getMainFields(params = null) {
        return http.get('/api/v1/depended-fields/main-fields/', {params});
    },
    getDependedFieldsConfig(params = null) {
        return http.get('/api/v1/depended-fields/depended-field/', {params});
    },
    getDependedFieldsData(params = null) {
        return http.get('/api/v1/depended-fields/', {params});
    },
    createDependedField(data) {
        return http.post('/api/v1/depended-fields/', data);
    },
    updateDependedField(id, data) {
        return http.put(`/api/v1/depended-fields/${id}/`, data);
    },
    removeDependedField(uuid) {
        return http.delete(`/api/v1/depended-fields/${uuid}/`)
    }
}

export default DependedFieldsService;
